<script setup>
import {XIcon} from "@heroicons/vue/solid";
import {computed, ref} from "vue";
import {usePage} from "@inertiajs/inertia-vue3";

const props = defineProps({});

const modernizrTests = () => {
    const tests = Object.keys(Modernizr);

    const failures = tests.filter(test => !Modernizr[test]);

    return failures.length > 0;
}

const app = computed(() => {
    return usePage().props.value.app;
});

const canShowWarning = localStorage ? ref(localStorage.getItem('feature-warning') !== '1') : true;

const showFeatureWarning = computed(() => {
    return  modernizrTests() && canShowWarning.value;
});

const hideFeatureWarning = () => {
    localStorage.setItem('feature-warning', '1');
    canShowWarning.value = false;
}

</script>

<template>
    <div>
        <div class="bg-tertiary text-white p-5 text-center prose max-w-none relative" v-if="showFeatureWarning">
            <div class="font-bold text-red-500">Your browser is missing some features required by {{ app.name }}.</div>
            <div class="text-sm">
                You can continue to use the site, but we cannot promise everything will work as intended.
            </div>
            <div class="text-sm">
                you may want to consider using a more modern browser. We recommend any of the latest versions of
                <a href="https://www.mozilla.org/en-US/firefox/new/" class="text-white font-bold" target="_blank">Firefox</a>,
                <a href="https://www.google.com/chrome/" class="text-white font-bold" target="_blank">Chrome</a>,
                <a href="https://www.microsoft.com/en-us/edge" class="text-white font-bold" target="_blank">Edge</a> or
                <a href="https://www.apple.com/safari/" class="text-white font-bold" target="_blank">Safari</a></div>

            <button class="absolute right-5 top-5 p-2 rounded bg-primary-dark" @click.prevent="hideFeatureWarning">
                <XIcon class="w-5" />
            </button>
        </div>
    </div>
</template>

<style scoped>

</style>
